import React from 'react';
import Slider, { SliderProps } from 'rc-slider';
import 'rc-slider/assets/index.css';
import twConfig from '@gik/core/tailwind.config';

export default function RangeSlider({ ...props }: SliderProps): React.ReactElement {
  return (
    <Slider
      railStyle={{
        height: 10,
        backgroundColor: twConfig.theme.colors.neutral[400],
      }}
      trackStyle={{
        height: 10,
        backgroundColor: twConfig.theme.colors.primary[500],
      }}
      handleStyle={{
        height: 17,
        width: 17,
        backgroundColor: twConfig.theme.colors.white,
        border: 0,
        boxShadow: '0px 1px 2px 1px rgba(0,0,0,0.3)',
      }}
      {...props}
    />
  );
}
